<script>
  import RfpManagerDropdownActions from 'rfp/rfp-manager/main/pages/components/RfpManagerDropdownActions.svelte';
  import manageUsersService, {
    ACCOUNT_ADMIN, ACCOUNT_MANAGER, UNVERIFIED_USER_TYPE, VERIFIED_USER_TYPE
  } from 'vRoot/account-profile/modules/manage-users/services/account-manage-users-list.service';
  import {getContext} from 'svelte';
  import  ManageUserAssignmentsDialog
    from 'vRoot/account-profile/modules/manage-users/actions/ManageUserAssignmentsDialog.svelte';
  import  ShowUserAssignmentsDialog
    from 'vRoot/account-profile/modules/manage-users/actions/ShowUserAssignmentsDialog.svelte';
  import {SvelteDialog} from 'root/v-app/rbServices';
  import Button from 'vRoot/account-profile/modules/manage-users/Button.svelte';
  import ChangeAccountType
    from 'vRoot/account-profile/modules/manage-users/manage-agency-users/ChangeAccountType.svelte';

  export let userAccount, isAdmin = false;

  const ACTIONS = [
    {
      id: 'assignments',
      icon: 'perm_contact_calendar',
      label: 'Assignments',
      action: manageAssignments,
      isApplicable: () => true,
    },
    {
      id: 'accountType',
      icon: 'perm_contact_calendar',
      label: 'Change Account Type',
      action: changeAccountType,
      isApplicable: ua => !ua.currentUser,
    },
    {
      id: 'profile',
      icon: 'person',
      label: 'Edit Profile',
      action: editUser,
      isApplicable: ua => ua.currentUser || ua.status !== 'INVITED',
    },
    {
      id: 'deactivate',
      icon: 'block',
      label: 'Deactivate User',
      action: deactivateUser,
      isApplicable: ua => !ua.currentUser && ua.status === 'ACTIVE',
    },
    {
      id: 'confirm',
      icon: 'check_circle',
      label: 'Activate User',
      action: verifyUser,
      isApplicable: ua => !ua.currentUser && ua.status === 'UNVERIFIED',
    },
    {
      id: 'resend',
      icon: 'email',
      label: 'Resend Invitation',
      action: resendInvitation,
      isApplicable: ua => !ua.currentUser && ua.status === 'INVITED',
    },
    {
      id: 'remove',
      icon: 'delete',
      label: 'Remove User',
      action: removeInvitation,
      isApplicable: ua => !ua.currentUser && ua.status === 'INVITED',
    },
  ];

  const usersContext = getContext('users');
  const account = usersContext.getAccount();

  let actions = [];

  $: actions = ACTIONS.filter(a => a.isApplicable(userAccount));

  function manageAssignments() {
    SvelteDialog.show(ManageUserAssignmentsDialog, {userAccount})
      .then(managedAccountsChanges => {
        usersContext.reload();
        if(managedAccountsChanges)
          manageUsersService.showAssignmentsChangedDialog({ isUser: userAccount.isUser, userId: userAccount._id, ...managedAccountsChanges });
      });
  }

  function showAssignments() {
    SvelteDialog.show(ShowUserAssignmentsDialog, {userAccount});
  }

  function changeAccountType() {
    SvelteDialog.show(ChangeAccountType, {userAccount})
      .then(usersContext.reload);
  }

  function editUser() { // TODO: this does nothing, need to consult with Joseph
    if(userAccount.currentUser) {
      manageUsersService.gotoUserProfile();
    } else {
      const userData = {
        id: userAccount._id,
        firstName: userAccount.firstName,
        lastName: userAccount.lastName,
        emailAddress: userAccount.emailAddress,
        phone: userAccount.phone,
        jobTitle: userAccount.jobTitle,
        role: userAccount.isAdmin? ACCOUNT_ADMIN: ACCOUNT_MANAGER,
        type: userAccount.status === 'ACTIVE'? VERIFIED_USER_TYPE: UNVERIFIED_USER_TYPE,
      };

      manageUsersService.editUser(account.id, userData)
        .then(usersContext.reload)
    }
  }

  function deactivateUser() {
    manageUsersService.deactivateUser(account.id, userAccount._id)
      .then(usersContext.reload)
  }

  function verifyUser() {
    manageUsersService.confirmUser(account.id, userAccount._id)
      .then(usersContext.reload)
  }

  function resendInvitation() {
    manageUsersService.resendUserInvitation(account.id, userAccount._id)
      .then(usersContext.reload);
  }

  function removeInvitation() {
    manageUsersService.removeInvitation(account.id, userAccount._id)
      .then(usersContext.reload);
  }

</script>

{#if isAdmin}
  <RfpManagerDropdownActions
    items="{actions}"
    align="bottom-end"
    mode="Light"
    grow="{true}"
    on:input={ev => ev.detail.action()}
  >
  <span slot="value"
        class="ManageButton"
        data-icon-before="settings"
  >
    Manage
  </span>
  </RfpManagerDropdownActions>
{:else}
  <Button
    icon="perm_contact_calendar"
    onClick={showAssignments}
  >
    Assignments
  </Button>
{/if}

<style lang="stylus">
  .ManageButton {
    display: flex;

    &:before {
      margin-right: 5px;
      font-size: 18px;
    }
  }
</style>
